__turbopack_context__.v({
  "ageApply": "index-module-scss-module__qzCy8W__ageApply",
  "ageRestrict": "index-module-scss-module__qzCy8W__ageRestrict",
  "ageRestrictLink": "index-module-scss-module__qzCy8W__ageRestrictLink",
  "boxComandsWrapper": "index-module-scss-module__qzCy8W__boxComandsWrapper",
  "button": "index-module-scss-module__qzCy8W__button",
  "errorHolder": "index-module-scss-module__qzCy8W__errorHolder",
  "extrasTitle": "index-module-scss-module__qzCy8W__extrasTitle",
  "header": "index-module-scss-module__qzCy8W__header",
  "item": "index-module-scss-module__qzCy8W__item",
  "modal": "index-module-scss-module__qzCy8W__modal",
  "note": "index-module-scss-module__qzCy8W__note",
  "sub": "index-module-scss-module__qzCy8W__sub",
  "ticketTypes": "index-module-scss-module__qzCy8W__ticketTypes",
  "ticketsHelper": "index-module-scss-module__qzCy8W__ticketsHelper",
  "ticketsHelperDone": "index-module-scss-module__qzCy8W__ticketsHelperDone",
  "ticketsSectionHeader": "index-module-scss-module__qzCy8W__ticketsSectionHeader",
  "title": "index-module-scss-module__qzCy8W__title",
  "variant": "index-module-scss-module__qzCy8W__variant",
});
